import { AxiosResponse } from 'axios';
import ApiService from './api';
import { Admin, CreatedAdmin, UpdatedAdmin } from 'shared/types';

type ChangeAdminPasswordRequest = {
  password: string;
};

export const getAdmins = async (
  page: number,
  limit: number,
  orderBy: { orderBy?: string },
  search: { search?: string }
): Promise<AxiosResponse<Admin[]>> =>
  await ApiService.get<Admin[]>('users', { page, limit, ...orderBy, ...search });

export const deleteAdmin = async (id: string): Promise<void> =>
  await ApiService.delete<{ users: string[]; isStudent?: boolean; }, void>('users', { users: [id], isStudent: false });

export const addAdmin = async (admin: CreatedAdmin): Promise<AxiosResponse<Admin>> =>
  await ApiService.post<CreatedAdmin, Admin>('users', {
    ...admin
  });

export const updateAdmin = async (id: string, admin: UpdatedAdmin): Promise<AxiosResponse<Admin>> =>
  await ApiService.patch<UpdatedAdmin, Admin>(`users/${id}`, {
    ...admin
  });

export const updateTag = async (id: string, body: {tag: string}): Promise<AxiosResponse<string>> =>
  await ApiService.patch<{tag: string}, string>(`profiles/${id}`, body);

export const changeAdminPassword = async (
  id: string,
  password: string
): Promise<AxiosResponse<void>> =>
  await ApiService.patch<ChangeAdminPasswordRequest, void>(`users/${id}/change-password`, {
    password
  });